import React, { createContext } from 'react';

interface UniversalSearchContextValue {
  isLoading?: boolean;
  searchType?: any;
  defaultSearchResource?: any;
  searchTypeOptions?: any[];
}

interface UniversalSearchProviderProps extends UniversalSearchContextValue {
  children?: React.ReactNode;
  [key: string]: any;
}

const UniversalSearchContext = createContext<UniversalSearchContextValue>(
  {} as UniversalSearchContextValue,
);

/**
 * Universal search data provider.
 */
function UniversalSearchProvider({
  isLoading,
  defaultSearchResource,
  searchType,
  searchTypeOptions,
  ...props
}: UniversalSearchProviderProps) {
  // Provider payload.
  const provider = {
    isLoading,
    searchType,
    defaultSearchResource,
    searchTypeOptions,
  };

  return <UniversalSearchContext.Provider value={provider} {...props} />;
}

const useUniversalSearchContext = () =>
  React.useContext(UniversalSearchContext);

export { UniversalSearchProvider, useUniversalSearchContext };
